import axios from "axios";
import { notification,Alert } from "antd";

import {
  LoadingOutlined,
  AppleFilled 
} from "@ant-design/icons";
var edi = require("encrypt-decrypt-it");
const http = require("http");
const request = require("request");
const fs = require("fs");
// const _API_URL = 'http://34.221.95.211:8888';
// const _API_URL = 'https://pdapiv1.tribaltmh.com';

//  const savedEnv = localStorage.getItem("ENV") || "";
const savedEnv = "PRODUCTION";

const EASYPOST_API_KEY = 'EZTKb701ed65254f4d80ba606c453053d01ePBRk3k36HvaiEY56gUhThw';

const _PROD_API = "https://pdapiv1.projectdasein.com";
const _DEV_API = "https://devapi.projectdasein.com";
const _BETA_API = "https://betaapi.projectdasein.com";
// const _DEV_API = 'http://35.89.14.47:8888';

const _API_URL =
  savedEnv == "DEVELOPMENT" ? _DEV_API : savedEnv == "BETA" ? _BETA_API : _PROD_API;

const _APP_URL = window.location.origin+'/';

// const _APP_URL = savedEnv == "DEVELOPMENT" ? window.location.origin+'/' : 'https://plans.aletheia.run/';


// const _API_URL = (savedEnv=="PRODUCTION" ? 'https://pdapiv2.projectdasein.com' : 'https://devapi.projectdasein.com');
const _SLS_API = "https://ll881c4d4c.execute-api.us-west-2.amazonaws.com";
const _ML_BULK_API = "http://54.245.153.17:8888/pd-ml-upload";

export const APP_URL = _APP_URL;
export const API_BASE_V2 = _API_URL;
export const API_BASE = _API_URL;
export const APP_ENV = savedEnv;
export const PD_ICON = "../assets/images/logo.png";
// export const PD_SOCKET_URI  = "http://35.89.14.47:3333";
export const PD_SOCKET_URI = "https://ws.projectdasein.com";




export function _ENV() {
  return savedEnv;
}


export function AppSupportedInfo ({isClosable}) {

  return( <div className="appInfo">
    <Alert
    className="alert-info"
    message={<b> iOS Exclusive Release!</b>}
    description="Our app is currently available for iOS only. We’re working on an Android version—stay tuned!"
    type="info"
    icon={<AppleFilled style={{fontSize:"50px"}} />}
    showIcon
    closable={isClosable}
  />
    </div>);
};



const pdAPIFetch = async (url, options = {}) => {
  // Get the authentication token from local storage or wherever it's stored
  const authToken = localStorage.getItem("is_auth");

  
  // Add the authentication token to the headers
  const headers = {
    "Content-Type": "application/json",
    "x-auth-token": `${authToken}`,
    ...options.headers,
  };

  // Make the fetch call with the modified headers
  return fetch(url, { ...options, headers });
};

function hashCode(string) {
  var hash = 0;
  for (var i = 0; i < string.length; i++) {
    var code = string.charCodeAt(i);
    hash = (hash << 5) - hash + code;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

export function timefix(thisTime) {
  const dateString = thisTime;
  const formattedDate = new Date(dateString);

  const formattedDateString = formattedDate.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  });

  const formattedTimeString = formattedDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  });

  const finalOut = `${formattedDateString} : ${formattedTimeString}`;

  return finalOut;
}

export async function mlBulkUpload(mlReq) {
  console.log(mlReq);

  const formData = new FormData();
  // Append the additional inputs to the FormData object
  formData.append("ml_type", mlReq.modal_type);
  formData.append("ml_version", mlReq.model_version);
  // formData.append('files', mlReq.ml_files);

  console.log(mlReq.ml_files);

  for (let i = 0; i < mlReq.ml_files.length; i++) {
    formData.append(`ml_files`, mlReq.ml_files[i]["originFileObj"]);
  }

  // Make the fetch request
  const response = await pdAPIFetch(_ML_BULK_API, {
    method: "POST",
    body: formData, // Use the FormData object as the body
  });

  return await response.json();
}

export async function dfuUpload(dfuReq) {
  console.log(dfuReq);

  const formData = new FormData();

  // Append the file to the FormData object

  console.log(dfuReq.files[0]);
  formData.append("file", dfuReq.files[0]);

  // Append the additional inputs to the FormData object
  formData.append("sw_version", dfuReq.sw_version);
  formData.append("hw_version", dfuReq.hw_version);

  // Make the fetch request
  const response = await pdAPIFetch(_API_URL + `/api/firmware/upload`, {
    method: "POST",
    mode: "cors",
    body: formData, // Use the FormData object as the body
  });

  // // const formData  = new FormData();
  // const response = await pdAPIFetch (_API_URL + `/api/firmware/upload`, {
  //     method: 'POST',
  //     mode: 'cors',
  //     body: dfuReq
  // });
  return await response.json();
}

export async function getAllUsers(req) {
  const response = await pdAPIFetch(_API_URL + `/users-ls`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body:
      req.livemode || localStorage.livemode
        ? new URLSearchParams("livemode=true")
        : "",
  });
  return await response.json();
}
export async function updateRole(request) {
  const response = await pdAPIFetch(_API_URL + `/switch-role`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams("uid=" + request.id + "&role=" + request.role),
  });
  return await response.json();
}

export async function restPDVPassword(request) {
  const response = await pdAPIFetch(_API_URL + `/pdv-rest-pwd`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(
      "uid=" + request.user_id + "&password=" + request.password
    ),
  });
  return await response.json();
}

export async function metricDownload(request) {
  console.log(request);
  const { user, data, select_all } = request;
  const response = await pdAPIFetch(_SLS_API + `/pd-metric`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    // body: new URLSearchParams("email=" + user.email)
    body: JSON.stringify({
      uid: user.id,
      email: user.email,
      select_all: select_all,
      activity_ids: data.length > 0 ? data.join(",") : "null",
    }),
  });
  return await response.json();
}

// V1&v2 MERAGE APIS ENV

export async function deleteGiftSubscription(request) {
  try {
    const response = await pdAPIFetch(
      _API_URL + `/api/stripe/gift-subscription-delete`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        // body: new URLSearchParams("email=" + user.email)
        body: JSON.stringify(request),
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function shareCouponCode(request) {
  const response = await pdAPIFetch(_API_URL + `/api/pd/share/coupon`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    // body: new URLSearchParams("email=" + user.email)
    body: JSON.stringify(request),
  });
  return await response.json();
}

export async function pdvSyncAdditionalModal(request) {
  // request.live_sync =true;

  const response = await pdAPIFetch(_API_URL + `/pdv-ml-sync`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    // body: new URLSearchParams("email=" + user.email)
    body: JSON.stringify(request),
  });
  return await response.json();
}

export async function pushLiveModal(request) {
  request.live_sync = true;

  const response = await pdAPIFetch(_PROD_API + `/push-ml-model`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    // body: new URLSearchParams("email=" + user.email)
    body: JSON.stringify(request),
  });
  return await response.json();
}

export async function removeMlModal(request) {
  console.log(request);

  const response = await pdAPIFetch(API_BASE + `/rm-ml-model`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });
  return await response.json();
}
// V1&v2 MERAGE APIS ENV

export async function fetchMetricFile(request) {
  console.log(request);

  const response = await pdAPIFetch(_SLS_API + `/pd-metric-download`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams("email=" + request.email),
    // body: JSON.stringify({
    //     email: request.email,
    // })
  });
  return await response.json();
}

export async function deleteFirmWare(request) {
  const response = await pdAPIFetch(_API_URL + `/api/firmware/remove`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams("firmware=" + request),
  });
  return await response.json();
}

export async function softDeleteUser(request) {
  const response = await pdAPIFetch(_API_URL + `/api/user/softdelete`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams("uid=" + request.id + "&role=" + request.role),
  });
  return await response.json();
}
export async function restoreUser(request) {
  const response = await pdAPIFetch(_API_URL + `/api/user/restoreuser`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams("uid=" + request.id + "&role=" + request.role),
  });
  return await response.json();
}
export async function forceDelete(request) {
  const response = await pdAPIFetch(
    _API_URL + `/api/user/pdviewer-force-delete`,
    {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams("uid=" + request.id + "&role=" + request.role),
    }
  );
  return await response.json();
}
export async function getMlLists() {
  const response = await pdAPIFetch(_API_URL + `/api/mlmodel/list`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await response.json();
}

export async function getDFULists() {
  const response = await pdAPIFetch(_API_URL + `/api/firmware/list`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await response.json();
}

export async function downloadEX(urlReq) {
  // const URL = urlReq;
  const fileName = urlReq.split("/").pop();
  // await request(urlReq).pipe(fs.createWriteStream(fileName)).on('close', function() {
  //     console.log(`File has been downloaded to ${fileName}`);
  // });
  axios({
    url: urlReq,
    method: "GET",
    responseType: "blob", // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  });
}

export async function superUserLogin(request) {
  const response = await pdAPIFetch(_API_URL + `/api/user/dologin`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(
      "email=" +
        request.email.trim() +
        "&password=" +
        request.password.trim() +
        "&is_pdv=1"
    ),
  });

  return await response.json();
  // const {
  //     status,
  //     data,
  //     message
  // } = await response.json();
  // if (status === "success") {
  //    const {user_type,token,is_role} =data;

  //    if(user_type!=="normal" || is_role==true ) {
  //        //  let encrypted_string = edi.encryptIt(request.email, request.password);
  //        localStorage.setItem('is_auth', token);
  //        localStorage.setItem('token', token);
  //        localStorage.setItem('auth_data', JSON.stringify(data));
  //        localStorage.setItem('is_role', (is_role ? 'admin' : 'user'));
  //        localStorage.setItem('is_email', request.email);
  //        return true;

  //    } else {
  //          return false;
  //    }

  // } else {
  //     return false;
  // }
  // const PD_PASSWORD = "pdroadmindash@123";
  // const PD_EMAIL = "pdrodashboard@support.com";
  // if(request.email==PD_EMAIL || request.password==PD_PASSWORD){
  //    let  encrypted_string = edi.encryptIt(PD_EMAIL,PD_PASSWORD);
  //     // console.log(encrypted_string);
  //     localStorage.setItem('is_auth',encrypted_string);
  //     return {status:true};
  // } else{
  //     return {status:false};
  // }
}

export async function getUserDetail(user) {
  console.log(user);
  // const formData  = new FormData();
  const response = await pdAPIFetch(_API_URL + `/all-run-view`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(
      "uid=" + user.id + "&username=" + user.first_name + " " + user.last_name
    ),
  });
  return await response.json();
}

export async function getRunDetails(run) {
  console.log(run);
  // const formData  = new FormData();
  const response = await pdAPIFetch(
    _API_URL + `/api/postrun/getrundetails_multiple_intervals`,
    {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "ro-auth-token": run.user_id,
      },
      body: new URLSearchParams("activity_id=" + run.id),
    }
  );
  return await response.json();
}
export async function getMetricUsers() {
  const response = await pdAPIFetch(_API_URL + `/metric-users`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return await response.json();
}
export async function getRunDetailsExtra(run) {
  console.log(run);
  // const formData  = new FormData();
  const response = await pdAPIFetch(
    _API_URL + `/api/postrun/getrundetails_multiple_intervals`,
    {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "ro-auth-token": run.user_id,
      },
      body: new URLSearchParams(
        "activity_id=" + run.id + "&pdviewer=true&auth=true"
      ),
    }
  );
  return await response.json();
}
export async function deleteActivityAPI(run) {
  console.log(run);
  // const formData  = new FormData();
  const response = await pdAPIFetch(_API_URL + `/api/running/deleteactivity`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "ro-auth-token": run.user_id,
      "x-activity-id": run.activity_id,
    },
    body: new URLSearchParams("activity_id=" + run.activity_id),
  });
  return await response.json();
}
export async function getRunFiles(run) {
  console.log(run);
  // const formData  = new FormData();
  const response = await pdAPIFetch(_API_URL + `/get-user-run`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "ro-auth-token": run.user_id,
    },
    body: new URLSearchParams("activity_id=" + run.id + "&uid=" + run.user_id),
  });
  return await response.json();
}
export async function getJsonFile(run) {
  console.log(run);
  // const formData  = new FormData();
  const response = await pdAPIFetch(_API_URL + `/json-download`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "ro-auth-token": run.user_id,
    },
    body: new URLSearchParams("activity_id=" + run.id + "&uid=" + run.user_id),
  });
  return await response.json();
}

export async function getPlans() {
  const authToken = localStorage.getItem("is_auth");
  // const formData  = new FormData();
  const response = await pdAPIFetch(_API_URL + `/api/stripe/pd/pricing`, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "x-auth-token": authToken,
    },
  });
  return await response.json();
}

export async function giftSubscriptionCheckout(req) {
  try {
    const authToken = localStorage.getItem("is_auth");

    const response = await pdAPIFetch(
      _API_URL + `/api/stripe/gift-subscription`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          // "Content-Type": "application/x-www-form-urlencoded",
          "x-auth-token": authToken,
        },
        body: JSON.stringify(req)
        // body: new URLSearchParams(
        //   "customer_id=" +
        //     req.customerId +
        //     "&pd_plan_id=" +
        //     req.gift_id +
        //     "&unit_amount=" +
        //     req.unit_amount +
        //     "&extra_data=" +JSON.stringify(req)+
        //     req.unit_amount +
        //     "&is_web=true"
        // ),
      }
    );

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function checkCouponCode(couponID,couponType,discountInfo) {

if(couponType==="promo"){
  couponID +=`&discount_info=${JSON.stringify(discountInfo)}`;
}

  try {
    const authToken = localStorage.getItem("is_auth");
    const response = await pdAPIFetch(_API_URL + `/api/stripe/check-coupon`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": authToken,
      },
      body: (couponType==="promo" ? new URLSearchParams("promo=" + couponID + "&is_web=true") : new URLSearchParams("coupon=" + couponID + "&is_web=true")) ,
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function createRetrunCheckout(req) {
  try {
    const authToken = localStorage.getItem("is_auth");

    const response = await pdAPIFetch(
      _API_URL + `/api/stripe/pd/return-shipment`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": authToken,
        },
        body: JSON.stringify(req)
        // body: new URLSearchParams(
        //   "customer_id=" + req.customerId + "&is_web=true"
        // ),
      }
    );

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}


export async function checkOutSession(req) {
  try {
    const authToken = localStorage.getItem("is_auth");

    const userAuth = JSON.parse(localStorage.getItem("auth_data") || "{}");

    const is_mode = req.type === "one_time" ? "payment" : "subscription";

    // const secoundrySub = (["developer","coach"].includes(userAuth.user_type) ? true : false);

    const secoundrySub = true

 const CHECKOUT_PAGE_URL= _APP_URL+'checkout-page?token='+authToken+'&'+new URLSearchParams(
      `&is_secondary=${secoundrySub}&pd_plan_id=${req.id}&title=${req.nickname}&email=${userAuth.email}&customer_id=${req.customer_id}&sensor_details={}&mode=${is_mode}&mode=${is_mode}&is_web=true&discount_info=${JSON.stringify(req.discount_info)}${req.coupon ? "&gift_code=" + req.coupon : (req.promo ? "&promotion_code=" + req.promo : "")} &payment_id=${req.paymentMethodId}&unit_amount=${req.unit_amount}${req.PLAN_TYPE=="GIFT" ? '&GIFT_PLAN=true' : ''}`
    )

    console.log(CHECKOUT_PAGE_URL)
    window.location.href = CHECKOUT_PAGE_URL;
    // const response = await pdAPIFetch(_API_URL + `/api/stripe/pd/subscribe`, {
    //   method: "POST",
    //   mode: "cors",
    //   headers: {
    //     "Content-Type": "application/x-www-form-urlencoded",
    //     "x-auth-token": authToken,
    //   },
    //   body: ,
    // });

    // console.log(response);
    // return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}


// export  async function flexibleShipping(params) {
//   const {country,postal_code}  = params;
//   try{
//   const epRes = await axios.post('https://api.easypost.com/v2/shipments', {
//     shipment: {
//       to_address: { country, zip: postal_code },
//       from_address: { country: 'US', zip: '94103' },
//       parcel: { length: 5, width: 3, height: 1, weight: 10 }
//     }
//   }, {
//     auth: { username: EASYPOST_API_KEY }
//   });

//   return epRes;
// } catch(err) {

//   console.log(err);
//   return false;
// }
  
// }


export async function flexibleShipping(params) {


  try {
    const response = await pdAPIFetch(_API_URL + `/api/pd/flexible-shipping`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      // body: new URLSearchParams("email=" + user.email)
      body: JSON.stringify(params),
    });
    return await response.json();


  } catch (err) {
    console.log('Error in flexibleShipping:', err);
    return false;
  }
}




export async function checkOutAfterSession(req) {
  try {

   

    const authToken = localStorage.getItem("is_auth") || req.token;

    const userAuth = JSON.parse(localStorage.getItem("auth_data") || "{}");

    const is_mode = req.type === "one_time" ? "payment" : "subscription";

    if (req.coupon) {
      req.gift_code = req.coupon;
    } else if (req.promo) {
      req.promotion_code = req.promo;
    }


    const response = await pdAPIFetch(_API_URL + `/api/stripe/pd/subscribe`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": authToken,
      },
      body :JSON.stringify(req)
      // body: new URLSearchParams(
      //   `pd_plan_id=${req.id}&title=${req.nickname}&email=${userAuth.email}&customer_id=${req.customer_id}&sensor_details={}&mode=${is_mode}&mode=${is_mode}&is_web=true&discount_info=${JSON.stringify(req.discount_info)}${req.coupon ? "&gift_code=" + req.coupon : (req.promo ? "&promotion_code=" + req.promo : "")} &payment_id=${req.paymentMethodId}&unit_amount=${req.unit_amount}&ship_rates=${JSON.stringify(req.ship_rates)}`
      // ),
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}


export async function fetchSessionData(req) {
  try {
    const authToken = localStorage.getItem("is_auth");

    const userAuth = JSON.parse(localStorage.getItem("auth_data") || "{}");


    const response = await pdAPIFetch(_API_URL + `/api/stripe/pd/get-session`, {
      method: "POST",
      mode: "cors",
      headers: {
        // "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": authToken,
      },
      body: JSON.stringify(req)
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function trailCheckOutSession(req) {
  try {
    const authToken = localStorage.getItem("is_auth");

    const userAuth = JSON.parse(localStorage.getItem("auth_data") || "{}");

    const is_mode = req.type === "one_time" ? "payment" : "subscription";

    req.email = userAuth.email;

    const response = await pdAPIFetch(_API_URL + `/api/stripe/pd/trail-subscribe`, {
      method: "POST",
      mode: "cors",
      headers: {
        // "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": authToken,
      },
      body: JSON.stringify(req)
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function stripeLoginVerify(req) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/stripe/login-verify`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": req.authToken,
      },
      body: new URLSearchParams("otp=" + req.otp),
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function nonUserStripeLogin(req) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/user/web-signup`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams("email=" + req.email),
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function emailStripeLogin(req) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/stripe/login`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams("email_id=" + req.email),
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function getBackGroundSync(urlReq) {
  try {
    const response = await pdAPIFetch(urlReq, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": localStorage.getItem("is_auth"),
      },
    });

    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}


export async function getSubscriptions() {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/stripe/pd/check`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": localStorage.getItem("is_auth"),
      },
    });

    if (response.status === 500) {
      localStorage.clear();
      setTimeout(() => window.location.reload(), 1500);
    }

    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function syncMessage(convo) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/stripe/create-message`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": localStorage.getItem("is_auth"),
      },
      body: new URLSearchParams(
        "userId=" +
          convo.user_id +
          "&message=" +
          convo.message +
          "&time=" +
          convo.time +
          "&support_link=" +
          convo.room
      ),
    });

    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function getMessages(req) {
  const response = await pdAPIFetch(_API_URL + `/api/stripe/support-messages`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams("uid=" + req),
  });
  return await response.json();
}

export async function unSubscription(subscription) {
  try {
    const response = await pdAPIFetch(
      _API_URL + `/api/stripe/pd/unsubscribe/${subscription.id}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "x-auth-token": localStorage.getItem("is_auth"),
        },
        body: new URLSearchParams(
          "action=" + subscription.action + "&ref_id=" + subscription.ref_id
        ),
      }
    );

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function forgotPdPassword(req) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/user/forgotpassword`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams("email=" + req.email),
    });

    console.log(response);

    if (response.status === 400) {
      notification.warning({
        message: "Email address not found.  Please create a new account.",
      });
    }

    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function forgotPassword() {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/user/pd-forgot-pass`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function VerifyOtp(otp) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/user/verifycode`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": localStorage.getItem("email_token"),
      },
      body: new URLSearchParams("otp=" + otp),
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

export async function pdUpdatePassword(payload) {
  try {
    const response = await pdAPIFetch(_API_URL + `/api/user/pd-reset-pass`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": payload.authToken,
      },
      body: new URLSearchParams("password=" + payload.password),
    });

    console.log(response);
    return await response.json();

    // Handle API response data if needed
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

// export async function getAllUsers() {
//     try{
//         const response = await pdAPIFetch (_API_URL+'/api/users');
//         return await response.json();
//     }catch(error) {
//         return [];
//     }
// }
// export async function getAllUsers(data) {
//     const response = await pdAPIFetch (_API_URL+`/users-ls`, {
//         method: 'POST',
//         headers: {'Content-Type': 'application/json'},
//         body: JSON.stringify({user: data})
//       })
//     return await response.json();
// }

// ─── Billing / Payment Methods ──────────────────────────────────────────────
// GET customer cards by email
// Backend: POST /api/billing/get-cards  { email }
// Response: { status: 'success', data: [ { id, brand, last4, exp_month, exp_year, name, is_default } ] }
export async function pdGetCustomerCards(req) {
  const response = await pdAPIFetch(_API_URL + `/api/billing/get-cards`, {
    method: "POST",
    body: JSON.stringify({ email: req.email }),
  });
  return await response.json();
}

// ADD new card
// Backend: POST /api/billing/add-card  { email, card_number, name, exp_month, exp_year, cvc }
// Response: { status: 'success', data: { ...card } }
export async function pdAddCard(req) {
  const email = localStorage.getItem("is_email") || "";
  const response = await pdAPIFetch(_API_URL + `/api/billing/add-card`, {
    method: "POST",
    body: JSON.stringify({ email, ...req }),
  });
  return await response.json();
}

// UPDATE card (expiry / name)
// Backend: POST /api/billing/update-card  { email, card_id, name, exp_month, exp_year }
// Response: { status: 'success' }
export async function pdUpdateCard(req) {
  const email = localStorage.getItem("is_email") || "";
  const response = await pdAPIFetch(_API_URL + `/api/billing/update-card`, {
    method: "POST",
    body: JSON.stringify({ email, ...req }),
  });
  return await response.json();
}

// DELETE card
// Backend: POST /api/billing/delete-card  { email, card_id }
// Response: { status: 'success' }
export async function pdDeleteCard(req) {
  const response = await pdAPIFetch(_API_URL + `/api/billing/delete-card`, {
    method: "POST",
    body: JSON.stringify(req),
  });
  return await response.json();
}

// SET DEFAULT card
// Backend: POST /api/billing/set-default-card  { email, card_id }
// Response: { status: 'success' }
export async function pdSetDefaultCard(req) {
  const response = await pdAPIFetch(_API_URL + `/api/billing/set-default-card`, {
    method: "POST",
    body: JSON.stringify(req),
  });
  return await response.json();
}
